import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-front-partnership',
  templateUrl: './front-partnership.component.html',
  styleUrls: ['./front-partnership.component.scss']
})
export class FrontPartnershipComponent implements AfterViewInit {

  public company_uuid;
  public dashboard: any = { partners: [], transactions: [] };
  public is_loading_dashboard: boolean = false;
  public filter: any = {};
  @ViewChild('table', { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService) {
    this.setDefaultDateRange();
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
      if (this.tb) {
        this.init();
      }
    });
  }

  ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    await this.loadDashboard();
    const setting = {
      post: { url: '/admin/app/partnership/get', data: { uuid: this.company_uuid } },
      disabled_pagenat: true,
      fields: [
        { label: 'No', type: 'index' },
        { label: 'Name', type: 'string', key: 'name' },
        { label: 'Sort', type: 'string', key: 'sort' },
        { label: 'Link', type: 'string', key: 'link' },
        { label: 'Status', type: 'status', key: 'status' },
        { label: 'View', type: 'link', key: 'uuid', link: '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + '/partnership/form', hide: true },
        { label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_partnership', title: 'name', hide: true },
      ]
    };
    this.tb.init(setting);
  }

  setDefaultDateRange() {
    const today = new Date();
    const from = new Date();
    from.setDate(today.getDate() - 29);
    this.filter.from = this.toDateInput(from);
    this.filter.to = this.toDateInput(today);
  }

  toDateInput(date: Date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  async loadDashboard() {
    this.is_loading_dashboard = true;
    const rtn: any = await this.http.post('/admin/app/partnership/dashboard', {
      from: this.filter.from,
      to: this.filter.to
    });
    this.dashboard = rtn && rtn.status ? rtn : { partners: [], transactions: [] };
    this.is_loading_dashboard = false;
  }

  sum(key: string) {
    return (this.dashboard.partners || []).reduce((total, item) => total + parseFloat(item[key] || 0), 0);
  }

  matchedPartners() {
    return (this.dashboard.partners || []).filter(item => item.partner_player_id).length;
  }
}
